import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PermitRequestProvider } from './contexts/PermitRequestContext';
import NotFoundPage from './pages/not-found-page/NotFound.page';
import Style from './styles/App.module.css';
import AccessibilityStatementPage from './pages/accessibility-statement-page/AccessibilityStatement.page';
import HomePage from './pages/home-page/Home.page';
import PrivacyPolicyPage from './pages/privacy-policy-page/PrivacyPolicy.page';

function App() {

  return (
    <div className={Style.App}>
        <Routes>
          <Route path="/" element={<NotFoundPage />} />
          <Route path='/home/:projectId' element={<HomePage />} />
          <Route path="/permit-request/:projectId" element={<PermitRequestProvider />} />
          <Route path='/accessibility-statement-page/:projectId' element={<AccessibilityStatementPage />} />
          <Route path='/privacy-policy/:projectId' element={<PrivacyPolicyPage />} /> 
          <Route path='*' element={<NotFoundPage />} />
        </Routes>
    </div>
  );
}

export default App;
